/* 🤖 this file was generated by svg-to-ts */
export const PorIconFavorites: {
    name: 'favorites';
    data: string;
} = {
    name: 'favorites',
    data: `<svg viewBox="0 0 28 25" width="24" height="24"><path d="M12.374 3.302H28V25H0V0h10.04l2.334 3.302zm14.693 3.302V4.245H13.04l1.666 2.359h12.36zM14 20.254L18.944 23l-1.308-5.18L22 14.339l-5.753-.455L14 9l-2.247 4.883L6 14.338l4.364 3.483L9.056 23 14 20.254z" fill="currentColor" fill-rule="nonzero"/></svg>`
};
